import { useTranslation } from 'react-i18next'
import {
   Container,
   FilterWrap,
   LabelSearch,
   SortBarList,
   SortItem,
   TimeInpustWrap,
   selectStyles
} from './styled'
import { TFilterBarProps } from './types'
import { CiSearch } from 'react-icons/ci'
import { ChangeEvent, SyntheticEvent, memo } from 'react'
import Select from 'react-select'
import { IoMdArrowDropdown } from 'react-icons/io'
import { DateInput } from 'components'
import { useTypedSelector } from 'hooks'
import { ApiCategoryService, getMainCategorySelector } from 'store'
import useSWR from 'swr'
import { TCategories } from 'store/category/types'

export const ProductFilterBar = memo(
   ({ params, setParams, setIsInitialLoad, visibleCategory }: TFilterBarProps) => {
      const { t } = useTranslation()
      const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
         setIsInitialLoad(false)

         setParams((prev) => ({ ...prev, query: e.target.value }))
      }
      const { accessToken } = useTypedSelector((state) => state.user)

      const onDataChenge = (e: SyntheticEvent<Element, Event>, type: 'start' | 'end') => {
         const input = e.target as HTMLInputElement
         setIsInitialLoad(false)

         if (type === 'start') {
            setParams((prev) => ({ ...prev, date_start: input.value }))
         } else {
            setParams((prev) => ({ ...prev, date_end: input.value }))
         }
      }
      const { data: categories } = useSWR(
         ['getCategories', { limit: 600, skip: 0 }],
         ([, par]) =>
            ApiCategoryService.getCategories({ ...par, token: accessToken || '' }),
         { revalidateOnFocus: false, keepPreviousData: true, revalidateIfStale: false }
      )

      const onSelectChange = (value: unknown) => {
         const newValue = value as { label: string; value: string } | undefined
         setParams((prev) => ({ ...prev, category: newValue }))
         setIsInitialLoad(false)
      }

      const onSortClick = (sortBy: string) => {
         setParams((prev) => ({ ...prev, sortBy, order: prev.order === 1 ? -1 : 1 }))
      }

      return (
         <Container>
            <FilterWrap>
               <LabelSearch>
                  <CiSearch />
                  <input
                     onChange={onSearch}
                     value={params.query}
                     placeholder={t('search')}
                  />
               </LabelSearch>
               <TimeInpustWrap>
                  <DateInput
                     onChange={(e) => onDataChenge(e, 'start')}
                     value={params.date_start}
                  />
                  <DateInput
                     onChange={(e) => onDataChenge(e, 'end')}
                     value={params.date_end}
                  />
               </TimeInpustWrap>
               <Select
                  options={(categories?.data as TCategories)?.data?.map((item) => ({
                     value: item._id,
                     label: item.title
                  }))}
                  isClearable
                  placeholder={t('select.category')}
                  styles={selectStyles}
                  onChange={onSelectChange}
                  value={visibleCategory ? params.category : undefined}
               />
            </FilterWrap>
            <SortBarList>
               <SortItem>{t('barcode')}</SortItem>
               <SortItem>{t('photo')}</SortItem>
               <SortItem>{t('label')}</SortItem>
               <SortItem
                  $growth={params.order === -1}
                  onClick={() => onSortClick('createdAt')}
                  $active={params.sortBy === 'createdAt'}>
                  {t('publish.date')}
                  <IoMdArrowDropdown />
               </SortItem>
               <SortItem>{t('category')}</SortItem>
               <SortItem
                  $growth={params.order === -1}
                  onClick={() => onSortClick('price')}
                  $active={params.sortBy === 'price'}>
                  {t('price')}
                  <IoMdArrowDropdown />
               </SortItem>
            </SortBarList>
         </Container>
      )
   }
)
